import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
    templateUrl: './access-yet.component.html'
})
export class AccessYetComponent {

    constructor(
        private utilStorageService: UtilStorageService,
        private _router: Router,
		private _activatedRoute:ActivatedRoute) { }

    logout(): void {
        this.utilStorageService.signOut();
        this._router.navigate(["/auth/login"],{relativeTo:this._activatedRoute})
      }
 }